import $ from "jquery"

/**
 * Scripts for form message display
 */
$(function(){
  const form = $('.js-form-custom form');
  const acceptance = form.find('input[name="acceptance"]');
  const submitBtn = form.find('input[type="submit"]');
  const checkbox = form.find('.custom-acceptance input[type="checkbox"]');
  const textarea = form.find('textarea');
  var isSubmit = false;

  $('.section--hero-marketing__form form').find('br').remove();

  checkbox.on('change', function() {
    acceptance.val(($(this).is(':checked')) ? "on" : "");
    console.log('in');
  });

  submitBtn.on('click', function() {
    const $thisCheckbox = $(this).parents('form').find('.custom-acceptance input[type="checkbox"]');
    checkboxValidation($thisCheckbox);
    isSubmit = true;
    checkSubmit();
  });

  $('input[name="category[]"]').on('change', function() {
    $('input[name="category[]"]').closest('label').removeClass('selected-category');
    if ($(this).is(':checked')) {
      $('input[name="category[]"]').not(this).prop('checked', false).closest('label').removeClass('selected-category');
      $(this).closest('label').addClass('selected-category');
    } else {
      $(this).prop('checked', false);
    }
  });

  function checkSubmit() {
    if (isSubmit) {
      checkbox.on('click', function() {
        const $this = $(this);
        checkboxValidation($this);
      });
      textarea.on('keyup paste', function() {
        const $this = $(this);
        if ($this.val() == '') {
          $this.addClass('wpcf7-not-valid');
        } else {
          $this.removeClass('wpcf7-not-valid');
          $this.next('.wpcf7-not-valid-tip').hide();
        }
      });
    }
  }

  function checkboxValidation($this) {
    if ($this.is(':checked')) {
      $this.removeClass('wpcf7-not-valid');
    } else {
      $this.addClass('wpcf7-not-valid');
    }
  }

  if(window.location.hash == '#igaming'){
    $('.js-form-igaming').removeClass('d-none');
    $('.js-form-loader').addClass('d-none');
  }else{
    $('.js-form-base').removeClass('d-none');
    $('.js-form-loader').addClass('d-none');
  }
});